module.exports = __webpack_public_path__ + "img/about.2ff19cc9.png";